import React, { useEffect, useState } from "react";
import "./index.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import { Grid } from "@mui/material";
import TopCard from "./topCard/TopCard";
import AllOrderTab from "../orders/orderTabs/AllOrderTab";

// Icon
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import orderStore from "../../stores/orderStore";
import usersStore from "../../stores/usersStore";
import productStore from "../../stores/productStore";
import RevenueLineChart from "./revenueLineChart/RevenueLineChart";
import paymentStore from "../../stores/paymentStore";
import SalesByCategoryPieChart from "./salesByCategoryPieChart/SalesByCategoryPieChart";

const Dashboard = () => {
  const SidebarActivePage = sidebarActivePage();

  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();
  const PaymentStore = paymentStore();

  const [dataLoading, setDataLoading] = useState(true);
  const [topLoading, setTopLoading] = useState(true);
  const [topData, setTopData] = useState([
    {
      id: 1,
      title: "Total Earning",
      value: "0",
      linkName: "View net earning",
      linkTo: "/dashboard",
      icon: <CurrencyRupeeRoundedIcon className="icon" />,
      backgroundIcon: "#daf4f0",
      colorIcon: "#1eb3a0",
    },
    {
      id: 2,
      title: "Orders",
      value: "0",
      linkName: "View all orders",
      linkTo: "/orders",
      icon: <WorkRoundedIcon className="icon" />,
      backgroundIcon: "#dff0fa",
      colorIcon: "#299edd",
    },
    {
      id: 3,
      title: "Users",
      value: "0",
      linkName: "View all user",
      linkTo: "/users",
      icon: <PeopleRoundedIcon className="icon" />,
      backgroundIcon: "#fef4e4",
      colorIcon: "#f8bf5e",
    },
    {
      id: 4,
      title: "Product",
      value: "0",
      linkName: "View all products",
      linkTo: "/product",
      icon: <Inventory2RoundedIcon className="icon" />,
      backgroundIcon: "#e2e5ed",
      colorIcon: "#44558c",
    },
  ]);

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Dashboard" });
  }, []);

  useEffect(() => {
    if (
      !ProductStore.isLoading &&
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading
    ) {
      let totalEarning = 0;
      var totalOrders = 0;
      if (OrderStore.orderDetail) {
        OrderStore.orderDetail.map((item) => {
          if (item.order_delivery_status === "Delivered") {
            totalEarning = totalEarning + item.purchasePrice;
          }
        });
        totalOrders = OrderStore.orderDetail.length;
      }

      const totalUsers = UsersStore.allUser?.length ?? 0;
      const totalProduct = ProductStore.mProduct?.length ?? 0;

      setTopData([
        {
          id: 1,
          title: "Total Earning",
          value: `₹${(totalEarning / 1000).toFixed(2)}k`,
          linkName: "View net earning",
          linkTo: "/dashboard",
          icon: <CurrencyRupeeRoundedIcon className="icon" />,
          backgroundIcon: "#daf4f0",
          colorIcon: "#1eb3a0",
        },
        {
          id: 2,
          title: "Orders",
          value: totalOrders,
          linkName: "View all orders",
          linkTo: "/orders",
          icon: <WorkRoundedIcon className="icon" />,
          backgroundIcon: "#dff0fa",
          colorIcon: "#299edd",
        },
        {
          id: 3,
          title: "Users",
          value: totalUsers,
          linkName: "View all user",
          linkTo: "/users",
          icon: <PeopleRoundedIcon className="icon" />,
          backgroundIcon: "#fef4e4",
          colorIcon: "#f8bf5e",
        },
        {
          id: 4,
          title: "Product",
          value: totalProduct,
          linkName: "View all products",
          linkTo: "/product",
          icon: <Inventory2RoundedIcon className="icon" />,
          backgroundIcon: "#e2e5ed",
          colorIcon: "#44558c",
        },
      ]);

      setTopLoading(false);
      setDataLoading(false);
    }
  }, [
    ProductStore.isLoading,
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
  ]);

  return (
    <div className="dashboard">
      <Grid container spacing={2} className="top-dashboard">
        {topData.map((item) => (
          <Grid item xs={12} sm={6} md={6} lg={3} key={item.id}>
            <TopCard item={item} topLoading={topLoading} />
          </Grid>
        ))}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="revenue-line-chart-container">
            <div className="title">Revenue</div>
            <RevenueLineChart />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <div className="sales-by-category-pie-chart-container">
            <div className="title">Sales by Category</div>
            <SalesByCategoryPieChart />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8}>
          <div className="order-table">
            <div className="title">Recent Orders</div>
            <AllOrderTab dataLoading={dataLoading} isDashboard={true} />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
